import * as yup from 'yup'

export const addBeneficiaryConfirmSchema = () => {
  const password = yup.string().trim().required()
  const isDetailsCorrect = yup.boolean()

  const formFields = {
    password,
    isDetailsCorrect,
  }

  return yup.object(formFields)
}
